var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const SendSquare = (_a) => {
    var { color = '#00A3FF', fill = 'none', width = 64, height = 64 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M24.0007 58.6666H40.0007C53.334 58.6666 58.6673 53.3333 58.6673 39.9999V23.9999C58.6673 10.6666 53.334 5.33325 40.0007 5.33325H24.0007C10.6673 5.33325 5.33398 10.6666 5.33398 23.9999V39.9999C5.33398 53.3333 10.6673 58.6666 24.0007 58.6666Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M24 25.3599L32 17.3599L40 25.3599", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M32 17.3599V38.6932", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M16 44.0266C26.3733 47.4933 37.6267 47.4933 48 44.0266", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default SendSquare;
